import ApiClient from './client';
import store from '../../store';

import { getEnv } from '@/constants';

class BackendApiClient extends ApiClient {
  constructor() {
    super(getEnv('VUE_APP_BACKEND_SERVER') || '');
    this.maxAuthRetries = 5;
  }

  onUnauthorized(forced: boolean = false, error?: string): Promise<void> {
    return store.dispatch('fetchAccessToken', { isUnauthorized: true, error });
  }

  get authToken(): string {
    return store.getters.userAuthToken;
  }
}

export default new BackendApiClient();
